export function createResumeIntentKey(params: {
  ticketId?: string | null;
  frontImagePath?: string | null;
  agentSessionId?: string | null;
  pendingSubmittedMessageId?: string | null;
}): string | null {
  const ticketId = params.ticketId?.trim();
  if (ticketId) return `ticket:${ticketId}`;

  const frontImagePath = params.frontImagePath?.trim();
  if (frontImagePath) return `image:${frontImagePath}`;

  // A first-turn credit wall can occur before a ticket, render, or agent
  // session exists. The opaque submitted-message id is the durable identity of
  // that exact customer turn; never bind a resume capability to the raw text.
  const pendingSubmittedMessageId = params.pendingSubmittedMessageId?.trim();
  if (pendingSubmittedMessageId) {
    return `message:${pendingSubmittedMessageId}`;
  }

  const agentSessionId = params.agentSessionId?.trim();
  if (agentSessionId) return `session:${agentSessionId}`;

  return null;
}
